class EsaedroLookupItem {
    private _value: any;

    public get value() : any {
        return this._value
    }   

    public set value(newvalue: any) {
        this._value = newvalue
    }

    private _description: string = "";

    public get description() : string {
        return this._description
    }   

    public set description(newvalue: string) {
        this._description = newvalue
    }
    constructor(value:any,description:string) {
        this.value=value;
        this.description=description;
    }

}

export default EsaedroLookupItem;